import Vue from "vue";
import Router from "vue-router";
import index from "@/components/index";
import employeedashboard from "@/components/employeedashboard";
import JobProfile from "@/components/JobProfiles/main";
import Applications from "@/components/applications/main";
import AppVacancy from "@/components/applications/vacancies";
import Feedback from "@/components/applications/feedback";
import ApplicationDetail from "@/components/applications/details-page";
import Applicants from "@/components/applicants/main";
import Vacancies from "@/components/vacancies/main";
import VacancyDetail from "@/components/vacancies/details-page";
import TalentSearch from "@/components/talentSearch/main";
import TalentSearchDetail from "@/components/talentSearch/detail-page";
import Onboarding from "@/components/employees/Onboarding";
import onboarddetails from "@/components/employees/onboarddetails";
import onboardingedit from "@/components/employees/onboardingedit";
import employees from "@/components/employees/main";
import managers from "@/components/employees/managers";
import manager from "@/components/employees/manager";
import optmanagers from "@/components/employees/operationalManagers";
import optmanager from "@/components/employees/operationalManager";
import workers from "@/components/casualworker/main";
import appdetail from "@/components/career/forms";
import applicantdetail from "@/components/career/applicant";
import leaves from "@/components/leaves/leaves";
import monthLeaves from "@/components/leaves/monthLeaves";
import amendLeaves from "@/components/leaves/amendedLeaveByHODs";
import leavesettings from "@/components/leaves/leavesettings";
import attendance from "@/components/attendance/attendance";
import departments from "@/components/miscs/departments";
import birthdays from "@/components/miscs/birthdays";
import companydesignations from "@/components/miscs/companydesignations";
import companydepartments from "@/components/miscs/companydepartments";
import companyunits from "@/components/miscs/companyunits";
import departmentunits from "@/components/miscs/departmentunits";
import designationroles from "@/components/miscs/designationroles";
import designations from "@/components/miscs/designations";
import query from "@/components/discipline/query";
import employeeQuery from "@/components/discipline/employeeQuery";
import timesheet from "@/components/timesheet";
import employeeslist from "@/components/employees/employeeslist";
import disciplinaryMeasures from "@/components/discipline/disciplinaryMeasures";
import employeeDisciplinaryCase from "@/components/discipline/employeeDisciplinaryCase";
import trainingNeeds from "@/components/training/trainingNeeds";
import trainingNeedsHR from "@/components/training/trainingNeedsHR";
import teamTrainingNeeds from "@/components/training/teamTrainingNeeds";
import teamTrainingNeedsHR from "@/components/training/teamTrainingNeedsHR";
import confirmedTrainingNeeds from "@/components/training/confirmedTrainingNeeds";
import trainingProvider from "@/components/training/trainingProvider";
import trainingProgram from "@/components/training/trainingProgram";
import trainingPlan from "@/components/training/trainingPlan";
import skillGap from "@/components/training/skillGap";
import disciplinaryCase from "@/components/discipline/disciplinaryCase";
import JobProfileInfo from "@/components/JobProfiles/detail";
import editApplicant from "@/components/editApplicant";
import createOrganization from "@/components/createOrganization";
import updateOrganization from "@/components/updateOrganization";
import leaveTypeForm from "@/components/leaves/leaveTypeForm";
import rank from "@/components/rank";
import carloansetting from "@/components/miscs/carloansetting";
import profile from "@/components/employees/profile";
import details from "@/components/employees/details";
import wdetails from "@/components/casualworker/details";
import paidsalary from "@/components/employees/paidsalary";
import login from "@/components/login";
import forgotPassword from '@/components/forgotPassword'
import changePassword from "@/components/auth/changePassword";
import attendanceEmployee from "@/components/attendance/attendanceEmployee";
import attendanceEmployeeHR from "@/components/attendance/attendanceEmployeeHR";
import timesheetEmployee from "@/components/timesheetEmployee";
import colleagues from "@/components/employees/colleagues";
import leaveHistory from "@/components/leaves/leaveHistory";
import leaveRequest from "@/components/leaves/leaveRequest";
import leaveRequestHr from "@/components/leaves/leaveRequestHr";
import leavesTest from "@/components/leaves/leavesTest";
import departLeaves from "@/components/leaves/leavesByDepart";
import LeavesByManager from "@/components/leaves/leavesByManager";
import LeavesByManagerHR from "@/components/leaves/leavesByManagerHR";
import companies from "@/components/companies/main";
import companyform from "@/components/companies/form";
import ranks from "@/components/miscs/ranks";
import skills from "@/components/jobprofiles/skills";
import skillGrades from "@/components/jobprofiles/skillGrades";
import terminationType from "@/components/jobprofiles/terminationType";
import expenseType from "@/components/settings/expenseType";
import loanType from "@/components/loans/loanType";
import teamloan from "@/components/loans/loan/teamloan";
import teamloanHr from "@/components/loans/loan/hrTeamLoan";
import loanHistory from "@/components/loans/loan/loanHistory";
import loanRequest from "@/components/loans/loan/loanRequest";
import manualLoan from "@/components/loans/loan/manualloan";
import manualSalary from "@/components/payroll/manualpayitem";
import loanRequestHr from "@/components/loans/loan/loanRequestHr";
import hrLoan from "@/components/loans/loan/hrLoan";
import hrMonthLoan from "@/components/loans/loan/hrMonthLoan";
import agmloan from "@/components/loans/loan/agmloan";
import resources from "@/components/settings/resources";
import activities from "@/components/settings/activities";
import skillType from "@/components/jobprofiles/skillType";
import leaveTypeOrgAdmin from "@/components/leaves/leaveTypeOrgAdmin";
import jobview from "@/components/career/jobview";
import joblist from "@/components/career/joblist";
import applicantLogin from "@/components/applicantLogin";
import termination from "@/components/employees/termination";
import exit from "@/components/exit/exit";
import resignation from "@/components/resignation/resignation";
import resignationEmployee from "@/components/resignation/resignationEmployee";
import resignationHREmployee from "@/components/resignation/resignationHREmployee";
import retirement from "@/components/retirement/retirement";
import retirementEmployee from "@/components/retirement/retirementEmployee";
import retirementHREmployee from "@/components/retirement/retirementHREmployee";
import salaryElement from "@/components/payroll/salaryElement";
import subCategory from "@/components/payroll/subcategories";
import salaryGroup from "@/components/payroll/salaryGroup";
import salaryEmployee from "@/components/payroll/salaryEmployee";
import proratedSalaries from "@/components/payroll/proratedSalaries";
import salaryEmployeeItem from "@/components/payroll/salaryEmployeeItem";
import salaryGroupAttr from "@/components/payroll/salaryGroupAttr";
import salaryhistory from "@/components/payroll/salaryhistory";
import payslip from "@/components/payroll/payslip";
import payslipHr from "@/components/payroll/payslipHr";
import accountsettings from "@/components/settings/account";
import salaryview from "@/components/payroll/salaryview";
import salaryviewHR from "@/components/payroll/salaryviewHR";
import payrollitems from "@/components/payroll/payrollitems";
import expenselist from "@/components/expenses/Expense/index";
import approvedclaims from "@/components/expenses/Expense/approvedclaims";
import expenseEmplist from "@/components/expenses/Expense/listForEmp";
import expenseHrlist from "@/components/expenses/Expense/listForHr";
import expenseAGMlist from "@/components/expenses/Expense/listForAGM";
import expenseCASHIERlist from "@/components/expenses/Expense/listForCASHIER";
import expenseManagerlist from "@/components/expenses/Expense/listForManager";
import expenseManagerlist2 from "@/components/expenses/Expense/listForManager2";
import expenseManagerlistHR from "@/components/expenses/Expense/listForManagerHR";
import expenseDetail from "@/components/expenses/Expense/detail";
import expenseDetail2 from "@/components/expenses/Expense/detail2";
import cashAdvanceList from "@/components/expenses/CashAdvance/index";
import approvedadvances from "@/components/expenses/CashAdvance/approvedadvance";
import cashAdvanceEmpList from "@/components/expenses/CashAdvance/listForEmp";
import cashAdvanceHrList from "@/components/expenses/CashAdvance/listForHr";
import cashAdvanceAGMList from "@/components/expenses/CashAdvance/listForAGM";
import cashAdvanceCASHIERList from "@/components/expenses/CashAdvance/listForCASHIER";
import cashAdvanceManagerList from "@/components/expenses/CashAdvance/listForManager";
import cashAdvanceManagerList2 from "@/components/expenses/CashAdvance/listForManager2";
import cashRetirementList from "@/components/expenses/retirement";
import cashAdvanceDetail from "@/components/expenses/CashAdvance/detail";
import cashAdvanceDetail2 from "@/components/expenses/CashAdvance/detail2";
import cashAdvanceDetail3 from "@/components/expenses/CashAdvance/detail3";
import policies from "@/components/miscs/policies";
import promotion from "@/components/employees/promotion";
import performanceActivity from "@/components/performance/performanceActivity";
import goalLists from "@/components/performance/goalLists";
import MyGoals from "@/components/performance/MyGoals";
import MyGoalsHR from "@/components/performance/MyGoalsHR";
import EmployeeGoals from "@/components/performance/EmployeeGoals";
import EmployeeGoalsByTeam from "@/components/performance/EmployeeGoalsByTeam";
import HrEmployeeGoals from "@/components/performance/HrEmployeeGoals";
import ThirdRaterGoals from "@/components/performance/thirdratergoals";
import TeamGoals from "@/components/performance/TeamGoals";
import ManagerReviews from "@/components/review/managerReviews";
import ManagerReviewsHR from "@/components/review/managerReviewsHR";
import HRReviews from "@/components/review/hrReviews";
import MgtReviews from "@/components/review/mgtReviews";
import ReviewDetail from "@/components/review/reviewDetail";
import EmployeeReviewDetail from "@/components/review/employeeReviewDetail";
import HrReviewDetail from "@/components/review/hrReviewDetail";
import TeamGoalsHR from "@/components/performance/TeamGoalsHR";
import addGoalActivity from "@/components/performance/addGoalActivity";
import addGoal from "@/components/performance/addGoal";
import addGoalEmployee from "@/components/performance/addGoalEmployee";
import GoalDetail from "@/components/performance/GoalDetail";
import PartnerGoalDetail from "@/components/performance/PartnerGoalDetail";
import editGoalByTeam from "@/components/performance/editGoalByTeam";
import addGoalMeasurement from "@/components/performance/addGoalMeasurement";
import addJournal from "@/components/performance/addJournal";
import journals from "@/components/performance/journals";
import activityStatus from "@/components/settings/performance/activityStatus";
import fieldSet from "@/components/settings/performance/fieldSet";
import activityType from "@/components/settings/performance/activityType";
import activityCategory from "@/components/settings/performance/activityCategory";
import holiday from "@/components/miscs/holidays";
import keyPerformanceIndicator from "@/components/settings/performance/keyPerformanceIndicator";
import JobProfileGMD from "@/components/jobProfiles/jobProfileByGMD";
import ProbatedStaffList from "@/components/employees/ProbationList";
import HRProbatedStaffList from "@/components/employees/HrProbationList";
import HRProbatedExtensionStaffList from "@/components/employees/ProbationExtensionList";
import Transferedstafflist from "@/components/employees/employeeTransfer";
import EmployeeTransfer from "@/components/employees/HRemployeeTransfer";
import HODEmployeeTransfer from "@/components/employees/HODemployeeTransfer";
import departApprovedByGMD from "@/components/miscs/departApprovedByGMD";
import designationApprovedByGMD from "@/components/miscs/designationApprovedByGMD";
import companyUnitsApprovedByGMD from "@/components/miscs/companyUnitsApprovedByGMD";
import { authenticationService } from "@/services/authenticationService";
import { Role } from "@/helpers/role";
import StoreRequisitionList from "@/components/expenses/StoreRequisition/listForEmp";
import StoreRequisitionList2 from "@/components/expenses/StoreRequisition/listForManager";
import StoreRequisitionList2HR from "@/components/expenses/StoreRequisition/listForManagerHR";
import StoreRequisitionList3 from "@/components/expenses/StoreRequisition/listForSTORE";
import StoreRequisitionDetail from "@/components/expenses/StoreRequisition/detail2";
import PurchaseRequisitionList from "@/components/expenses/PurchaseRequisition/listForEmp";
import PurchaseRequisitionList2 from "@/components/expenses/PurchaseRequisition/listForManager";
import PurchaseRequisitionList2HR from "@/components/expenses/PurchaseRequisition/listForManagerHR";
import PurchaseRequisitionList3 from "@/components/expenses/PurchaseRequisition/listForREQ";
import PurchaseRequisitionDetail from "@/components/expenses/PurchaseRequisition/detail2";
import LoanApprovals from "@/components/loans/loan/loanApprovals";
import LeaveApprovals from "@/components/leaves/leavesApprovals";
import Salaryitemhistory from "@/components/payroll/salaryitemhistory.vue";
import questions from "../components/settings/performance/questions";
import reviewPeriod from "../components/review/reviewPeriod.vue";
import MyReviews from "../components/review/myReviews.vue";
import ManagerReviewDetail from "../components/review/managerReviewDetail.vue";
import OtherReviewDetail from "../components/review/otherReviewDetail.vue";
import OtherReviews from "../components/review/otherReviews.vue";
import ManagerReviewDetailHR from "../components/review/managerReviewDetailHR.vue";

Vue.use(Router);
const router = new Router({
  mode: "history",
  // base: 'light',
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/index",
      name: "indexs",
      component: index,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/employees",
      name: "employees",
      component: employees
      // meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/managers",
      name: "managers",
      component: managers
      // meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/manager/:id",
      name: "manager",
      component: manager
      // meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/optmanagers",
      name: "optmanagers",
      component: optmanagers
      // meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/optmanager/:id",
      name: "optmanager",
      component: optmanager
      // meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/probatedstafflist",
      name: "probatedstafflist",
      component: ProbatedStaffList,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/transferedstafflist",
      name: "transferedstafflist",
      component: Transferedstafflist,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/incomingstafflist",
      name: "incomingstafflist",
      component: HODEmployeeTransfer,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/probatedemployees",
      name: "probatedemployees",
      component: HRProbatedStaffList,
      meta: { authorize: [Role.HRAdmin] }
    },

    {
      path: "/employeeTransfer",
      name: "employeeTransfer",
      component: EmployeeTransfer,
      meta: { authorize: [Role.HRAdmin, Role.HCPM] }
    },
    {
      path: "/probatedEmployeeExtension",
      name: "probatedEmployeeExtension",
      component: HRProbatedExtensionStaffList,
      meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/workers",
      name: "workers",
      component: workers,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/appdetail/:id",
      name: "appdetail",
      component: appdetail
    },
    {
      path: "/applicantdetail/:id",
      name: "applicantdetail",
      component: applicantdetail
    },
    {
      path: "/employees-list",
      name: "employeeslist",
      component: employeeslist,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/employeedashboard",
      name: "employeedashboard",
      component: employeedashboard,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/job-profile",
      name: "jobprofile",
      component: JobProfile,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/accountsettings",
      name: "accountsettings",
      component: accountsettings,
      meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/promotion",
      name: "promotion",
      component: promotion,
      meta: { authorize: [Role.HRAdmin, Role.TLPM, Role.HCPM] }
    },
    {
      path: "/vacancies",
      name: "vacancies",
      component: Vacancies,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/applications",
      name: "applications",
      component: AppVacancy,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/appvacancy/:id",
      name: "appvacancy",
      component: Applications,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/feedback",
      name: "feedback",
      component: Feedback,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/applicants",
      name: "applicants",
      component: Applicants,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/talent-search",
      name: "talentSearch",
      component: TalentSearch,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/onboarding",
      name: "onboarding",
      component: Onboarding,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/leaves",
      name: "leaves",
      component: leaves,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/leaves-current-month",
      name: "MonthLeaves",
      component: monthLeaves,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/amendleaves",
      name: "amendleaves",
      component: amendLeaves,
      meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/leavesettings",
      name: "leavesettings",
      component: leavesettings,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/attendance",
      name: "attendance",
      component: attendance,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/departments",
      name: "departments",
      component: departments,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: "/birthdays",
      name: "birthdays",
      component: birthdays
      // meta: { authorize: [Role.Admin] }
    },
    {
      path: "/designations",
      name: "designations",
      component: designations,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: "/companydepartments",
      name: "companydepartments",
      component: companydepartments,
      meta: { authorize: [Role.HRAdmin, Role.HODR] }
    },
    {
      path: "/companydesignations",
      name: "companydesignations",
      component: companydesignations,
      meta: { authorize: [Role.HRAdmin, Role.HODR] }
    },
    {
      path: "/companyunits",
      name: "companyunits",
      component: companyunits,
      meta: { authorize: [Role.HRAdmin, Role.HODR] }
    },
    {
      path: "/departmentunits",
      name: "departmentunits",
      component: departmentunits,
      meta: { authorize: [Role.HRAdmin, Role.HODR] }
    },
    {
      path: "/designationroles",
      name: "designationroles",
      component: designationroles,
      meta: { authorize: [Role.HRAdmin, Role.HODR] }
    },
    {
      path: "/timesheet",
      name: "timesheet",
      component: timesheet,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/disciplinary-measures",
      name: "disciplinaryMeasures",
      component: disciplinaryMeasures,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/employee-disciplinary-case",
      name: "employeedisciplinarycase",
      component: employeeDisciplinaryCase,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/disciplinary-case",
      name: "disciplinarycase",
      component: disciplinaryCase,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/training-needs",
      name: "trainingNeeds",
      component: trainingNeeds,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/team-training-needs",
      name: "teamTrainingNeedsHR",
      component: teamTrainingNeeds,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/training-needs-hr",
      name: "trainingNeedsHR",
      component: trainingNeedsHR,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM] }
    },
    {
      path: "/loan-request-hr",
      name: "loanrequest",
      component: loanRequestHr,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM] }
    },
    {
      path: "/cash-advance-hr",
      name: "cashadvanceemplist",
      component: cashAdvanceHrList,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM] }
    },
    {
      path: "/expense-claims-hr",
      name: "expenseEmplist",
      component: expenseHrlist,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM] }
    },

    {
      path: "/leave-request-hr",
      name: "leaverequest",
      component: leaveRequestHr,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM] }
    },
    {
      path: "/leave-approvals",
      name: "leaveapprovals",
      component: LeaveApprovals,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/payslip-hr",
      name: "payslipEmployee",
      component: payslipHr,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, , Role.HCRM] }
    },
    {
      path: "/team-training-needs-hr",
      name: "teamTrainingNeeds",
      component: teamTrainingNeedsHR,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM] }
    },
    {
      path: "/confirmed-training-needs",
      name: "confirmedTrainingNeeds",
      component: confirmedTrainingNeeds,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.Employee] }
    },
    {
      path: "/training-provider",
      name: "trainingProvider",
      component: trainingProvider,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.Employee] }
    },
    {
      path: "/training-program",
      name: "trainingProgram",
      component: trainingProgram,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.Employee] }
    },
    {
      path: "/training-plan",
      name: "trainingPlan",
      component: trainingPlan,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.Employee] }
    },
    {
      path: "/skill-gap",
      name: "skillGap",
      component: skillGap,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR, Role.Employee] }
    },
    {
      path: "/job-profile-edit/:id",
      name: "jobprofileinfo",
      component: JobProfileInfo,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/job-profile-info",
      name: "createjobprofile",
      component: JobProfileInfo,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/vacancy/:id",
      name: "vacancydetail",
      component: VacancyDetail,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/addvacancy",
      name: "addvacancy",
      component: VacancyDetail,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/jobprofileGMD",
      name: "jobprofileGMD",
      component: JobProfileGMD,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/departApprovedByGMD",
      name: "departApprovedByGMD",
      component: departApprovedByGMD,
      meta: { authorize: [Role.Employee] }
    },

    {
      path: "/designationApprovedByGMD",
      name: "designationApprovedByGMD",
      component: designationApprovedByGMD,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/companyUnitsApprovedByGMD",
      name: "companyUnitsApprovedByGMD",
      component: companyUnitsApprovedByGMD,
      meta: { authorize: [Role.Employee] }
    },

    {
      path: "/applications/:id",
      name: "applicationDetail",
      component: ApplicationDetail,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR] }
    },

    {
      path: "/talent-search/:id",
      name: "talentSearchDetail",
      component: TalentSearchDetail
    },
    {
      path: "/create-organization",
      name: "createorganization",
      component: createOrganization
    },
    {
      path: "/update-organization",
      name: "updateorganization",
      component: updateOrganization,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: "/leave-type-form",
      name: "leavetypeform",
      component: leaveTypeForm,
      meta: { authorize: [Role.Admin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/rank",
      name: "rank",
      component: rank,
      meta: { authorize: [] }
    },
    {
      path: "/carloansetting",
      name: "carloansetting",
      component: carloansetting,
      meta: { authorize: [] }
    },
    {
      path: "/profile",
      name: "profile",
      component: profile,
      meta: { authorize: [] }
    },
    {
      path: "/employee-detail/:id",
      name: "employeedetail",
      component: details,
      meta: { authorize: [] }
    },
    {
      path: "/worker-detail/:id",
      name: "workerdetail",
      component: wdetails,
      meta: { authorize: [] }
    },
    {
      path: "/onboard-detail",
      name: "onboarddetails",
      component: onboarddetails,
      meta: { authorize: [] }
    },
    {
      path: "/onboarding-edit/:id",
      name: "onboarding-edit",
      component: onboardingedit,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR] }
    },
    {
      path: "/login",
      name: "login",
      component: login
    },
    {
      path: "/password-recovery",
      name: "forgotPassword",
      component: forgotPassword
    },
    {
      path: "/attendance-employee",
      name: "attendanceemployee",
      component: attendanceEmployee,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/attendance-employee-hr",
      name: "attendanceemployeeHR",
      component: attendanceEmployeeHR,
      meta: { authorize: [Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM] }
    },
    {
      path: "/timesheet-employee",
      name: "timesheetemployee",
      component: timesheetEmployee,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/colleagues",
      name: "colleagues",
      component: colleagues,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/leave-request",
      name: "leaverequest",
      component: leaveRequest,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/leave-history/:id",
      name: "leavehistory",
      component: leaveHistory,
      meta: { authorize: [Role.Employee, Role.HRAdmin, Role.HTD, Role.TLTD, Role.HCRM]  }
    },
    {
      path: "/leave-test",
      name: "leavestest",
      component: leavesTest,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/departleaves",
      name: "departleaves",
      component: departLeaves,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/leavesByManager",
      name: "leavesByManager",
      component: LeavesByManager,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/leavesByManager-hr",
      name: "leavesByManagerHR",
      component: LeavesByManagerHR,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/ranks",
      name: "ranks",
      component: ranks,
      meta: { authorize: [Role.HRAdmin, Role.HODR] }
    },
    {
      path: "/leave-type-org-admin",
      name: "leavetypeorgadmin",
      component: leaveTypeOrgAdmin,
      meta: { authorize: [Role.Admin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/companies",
      name: "companies",
      component: companies,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: "/addcompany",
      name: "addcompany",
      component: companyform,
      meta: { authorize: [Role.Admin] }
    },
    {
      path: "/skill",
      name: "skill",
      component: skills,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR, Role.Employee] }
    },
    {
      path: "/skill-type",
      name: "skilltype",
      component: skillType,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR, Role.Employee] }
    },
    {
      path: "/skill-grade",
      name: "skillgrade",
      component: skillGrades,
      meta: { authorize: [Role.HRAdmin, Role.TLMPR, Role.HODR, Role.Employee] }
    },
    {
      path: "/jobview/:id",
      name: "jobview",
      component: jobview
    },
    {
      path: "/joblist",
      name: "joblist",
      component: joblist
    },
    {
      path: "/applicant-login",
      name: "appplicantlogin",
      component: applicantLogin
    },
    {
      path: "/resignation",
      name: "resignation",
      component: resignation,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/retirement",
      name: "retirement",
      component: retirement,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/exit",
      name: "exit",
      component: exit,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/resignationEmployee",
      name: "resignationEmployee",
      component: resignationEmployee,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/retirementEmployeeHR",
      name: "retirementEmployeeHR",
      component: retirementHREmployee,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/resignationEmployeeHR",
      name: "resignationEmployeeHR",
      component: resignationHREmployee,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/retirementEmployee",
      name: "retirementEmployee",
      component: retirementEmployee,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/termination",
      name: "termination",
      component: termination,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/termination-type",
      name: "terminationtype",
      component: terminationType,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/expense-type",
      name: "expensetype",
      component: expenseType,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/loan-type",
      name: "loantype",
      component: loanType,
      meta: { authorize: [Role.HRAdmin, Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM] }
    },
    {
      path: "/loan-request",
      name: "loanrequest",
      component: loanRequest,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/manual-loan",
      name: "manualloan",
      component: manualLoan,
      meta: { authorize: [Role.HRAdmin, Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM] }
    },
    {
      path: "/manual-salary",
      name: "manualsalary",
      component: manualSalary,
      meta: { authorize: [Role.HRAdmin, Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM] }
    },
    {
      path: "/loan-history/:id",
      name: "loanhistory",
      component: loanHistory,
      meta: { authorize: [Role.Employee, Role.HRAdmin, Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM]  }
    },
    {
      path: "/loan-approvals",
      name: "loanapprovals",
      component: LoanApprovals,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/hr-loan-request",
      name: "hrloanrequest",
      component: hrLoan,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/hr-current-loan-request",
      name: "hrmonthloanrequest",
      component: hrMonthLoan,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/team-loan-request",
      name: "teamloanrequest",
      component: teamloan,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/team-loan-request-hr",
      name: "hrTeamLoan",
      component: teamloanHr,
      meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/agm-loan-request",
      name: "agmloanrequest",
      component: agmloan,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/resources",
      name: "resources",
      component: resources
      //meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/activities",
      name: "activities",
      component: activities
      //meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/salary-element",
      name: "salaryelement",
      component: salaryElement,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/salary-sub-category",
      name: "salarysubcategory",
      component: subCategory,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/salary-group",
      name: "salarygroup",
      component: salaryGroup,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/salary-employee",
      name: "salaryemployee",
      component: salaryEmployee,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/prorated-salaries",
      name: "proratedSalaries",
      component: proratedSalaries,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/salary-employee-item/:id",
      name: "salaryEmployeeItem",
      component: salaryEmployeeItem,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/salary-group-attr/:id",
      name: "salarygroupattr",
      component: salaryGroupAttr,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/payslip",
      name: "payslip",
      component: salaryhistory,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/reocurring-payslip",
      name: "reocurringpayslip",
      component: Salaryitemhistory,
      meta: { authorize: [Role.HRAdmin, Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM] }
    },
    {
      path: "/payslip-employee",
      name: "payslipEmployee",
      component: payslip,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/salaryview/:id",
      name: "salaryview",
      component: salaryview,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/salaryviewhr/:id",
      name: "salaryviewhr",
      component: salaryviewHR,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/payrollitems",
      name: "payrollitems",
      component: payrollitems,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/policies",
      name: "policies",
      component: policies,
      meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/expense-claims",
      name: "expenselist",
      component: expenselist,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/completed-expense-claims",
      name: "completedclaims",
      component: approvedclaims,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/expense-claims-employee",
      name: "expenseEmplist",
      component: expenseEmplist,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/expense-claims-manager",
      name: "expenseMaglist",
      component: expenseManagerlist,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/approved-expense-claims-manager",
      name: "approvedexpenseMaglist",
      component: expenseManagerlist2,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/expense-claims-manager-hr",
      name: "expenseMaglistHR",
      component: expenseManagerlistHR,
      meta: { authorize:  [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/expense-claims-agm",
      name: "expenseagmlist",
      component: expenseAGMlist,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/expense-claims-cashier",
      name: "expensecashierlist",
      component: expenseCASHIERlist,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/add-expense",
      name: "expenseDetail",
      component: expenseDetail2,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/add-store-requisition",
      name: "storeRequisitionDetail",
      component: StoreRequisitionDetail,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/add-purchase-requisition",
      name: "purchaseRequisitionDetail",
      component: PurchaseRequisitionDetail,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/add-expense-two",
      name: "expenseDetail2",
      component: expenseDetail,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM,
          Role.Employee
        ]
      }
    },
    {
      path: "/expense-detail-two/:id",
      name: "editExpense",
      component: expenseDetail,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM,
          Role.Employee
        ]
      }
    },
    {
      path: "/expense-detail/:id",
      name: "editExpense2",
      component: expenseDetail2,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM,
          Role.Employee
        ]
      }
    },
    {
      path: "/store-requisition-detail/:id",
      name: "editStoreRequisition",
      component: StoreRequisitionDetail,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM,
          Role.Employee
        ]
      }
    },
    {
      path: "/purchase-requisition-detail/:id",
      name: "editPurchaseRequisition",
      component: PurchaseRequisitionDetail,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM,
          Role.Employee
        ]
      }
    },
    {
      path: "/cash-advance",
      name: "cashadvancelist",
      component: cashAdvanceList,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/completed-cash-advance",
      name: "aprovedadvances",
      component: approvedadvances,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/cash-advance-employee",
      name: "cashadvanceemplist",
      component: cashAdvanceEmpList,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/cash-advance-manager",
      name: "cashadvancemaglist",
      component: cashAdvanceManagerList,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/approved-cash-advance-manager",
      name: "approvedcashadvancemaglist",
      component: cashAdvanceManagerList2,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/store-requisition-employee",
      name: "StoreRequisitionList",
      component: StoreRequisitionList,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/store-requisition-manager",
      name: "StoreRequisitionList2",
      component: StoreRequisitionList2,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/store-requisition-manager-hr",
      name: "StoreRequisitionList2HR",
      component: StoreRequisitionList2HR,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/store-requisition-store",
      name: "StoreRequisitionList3",
      component: StoreRequisitionList3,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/purchase-requisition-employee",
      name: "PurchaseRequisitionList",
      component: PurchaseRequisitionList,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/purchase-requisition-manager",
      name: "PurchaseRequisitionList2",
      component: PurchaseRequisitionList2,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/purchase-requisition-manager-hr",
      name: "PurchaseRequisitionList2HR",
      component: PurchaseRequisitionList2HR,
      meta: { authorize: [Role.HRAdmin, Role.HCRM, Role.TCRM]  }
    },
    {
      path: "/purchase-requisition-req",
      name: "PurchaseRequisitionList3",
      component: PurchaseRequisitionList3,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/cash-advance-agm",
      name: "cashadvanceagmlist",
      component: cashAdvanceAGMList,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/cash-advance-cashier",
      name: "cashadvancecashierlist",
      component: cashAdvanceCASHIERList,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/cash-retirement",
      name: "cashretirementlist",
      component: cashRetirementList
    },
    {
      path: "/add-cash-advance",
      name: "cashAdvanceDetail",
      component: cashAdvanceDetail2,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/add-cash-advance-hr",
      name: "cashAdvanceDetail3",
      component: cashAdvanceDetail3,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/add-cash-advance-two",
      name: "cashAdvanceDetail2",
      component: cashAdvanceDetail,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/cash-advance-detail/:id",
      name: "editcashAdvance",
      component: cashAdvanceDetail,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/cash-advance-detail-two/:id",
      name: "editcashAdvance2",
      component: cashAdvanceDetail2,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/paidsalary",
      name: "paidsalary",
      component: paidsalary
    },
    {
      path: "/add-performance-goal",
      name: "addGoal",
      component: addGoal,
      meta: { authorize: [Role.HRAdmin, Role.TLPM, Role.HCPM] }
    },
    {
      path: "/add-performance-goal-employee",
      name: "addGoalEmployee",
      component: addGoalEmployee,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/edit-performance-goal/:id",
      name: "editGoal",
      component: addGoal,
      meta: { authorize: [Role.HRAdmin, , Role.TLPM, Role.HCPM, Role.Employee] }
    },
    {
      path: "/edit-performance-team-goal/:id",
      name: "editGoalByTeam",
      component: editGoalByTeam,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/performance-goal/:id",
      name: "GoalDetail",
      component: GoalDetail,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/partner-goal/:id",
      name: "PartnerGoalDetail",
      component: PartnerGoalDetail,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/performance-goals",
      name: "goalLists",
      component: goalLists,
      meta: { authorize: [Role.HRAdmin, Role.TLPM, Role.HCPM] }
    },
    {
      path: "/my-performance-goals",
      name: "MyGoals",
      component: MyGoals,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/my-performance-goals-hr",
      name: "MyGoalsHR",
      component: MyGoalsHR,
      meta: { authorize: [Role.HRAdmin, Role.TLPM, Role.HCPM, Role.HCRM] }
    },
    {
      path: "/employee-performance-goals/:id",
      name: "employeeGoals",
      component: EmployeeGoals,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/hremployee-performance-goals/:id",
      name: "hremployeeGoals",
      component: HrEmployeeGoals,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/team-employee-performance-goals/:id",
      name: "employeeGoalsByTeam",
      component: EmployeeGoalsByTeam,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/review-detail/:id",
      name: "reviewDetail",
      component: ReviewDetail,
      meta: { authorize: [Role.Employee, Role.HRAdmin] }
    },
    {
      path: "/employee-review-detail/:id",
      name: "employeeReviewDetail",
      component: EmployeeReviewDetail,
      meta: { authorize: [Role.Employee] }
    },
   {
      path: "/manager-review-detail-hr/:id",
      name: "managerReviewDetailHR",
      component: ManagerReviewDetailHR,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/declined-manager-review",
      name: "otherReview",
      component: OtherReviews,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/declined-manager-review-detail/:id",
      name: "otherReviewDetail",
      component: OtherReviewDetail,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/manager-review-detail/:id",
      name: "managerReviewDetail",
      component: ManagerReviewDetail,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/hr-review-detail/:id",
      name: "hrReviewDetail",
      component: HrReviewDetail,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/manager-review",
      name: "managerReview",
      component: ManagerReviews,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/my-review",
      name: "myReview",
      component: MyReviews,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/manager-review-hr",
      name: "managerReviewHR",
      component: ManagerReviewsHR,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM, Role.HCRM] }
    },
    {
      path: "/hr-review",
      name: "hrReview",
      component: HRReviews,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/mgt-review",
      name: "mgtReview",
      component: MgtReviews,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/partner-performance-goals",
      name: "partnerGoals",
      component: ThirdRaterGoals,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/team-performance-goals",
      name: "TeamGoals",
      component: TeamGoals,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/team-performance-goals-hr",
      name: "TeamGoalsHR",
      component: TeamGoalsHR,
      meta: {
        authorize: [
          Role.HRAdmin,
          Role.HCPM,
          Role.HTD,
          Role.HCRM,
          Role.HODR,
          Role.TCRM,
          Role.TLCM,
          Role.TLMPR,
          Role.TLPM,
          Role.TLTD,
          Role.RM
        ]
      }
    },
    {
      path: "/edit-goal-general/:id",
      name: "editGoalGeneral",
      component: addGoal,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM] }
    },
    {
      path: "/add-goal-activity",
      name: "addGoalActivity",
      component: addGoalActivity,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM] }
    },
    {
      path: "/edit-goal-activity",
      name: "editGoalActivity",
      component: addGoalActivity,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM] }
    },
    {
      path: "/add-goal-measurement",
      name: "addGoalMeasurement",
      component: addGoalMeasurement,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM] }
    },
    {
      path: "/edit-goal-measurement",
      name: "editGoalMeasurement",
      component: addGoalMeasurement,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM] }
    },
    {
      path: "/performance-journals",
      name: "journals",
      component: journals,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM] }
    },
    {
      path: "/add-performance-journal",
      name: "addjournal",
      component: addJournal
      //meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/edit-performance-journal/:id",
      name: "editjournal",
      component: addJournal
      //meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/performance-activity",
      name: "performanceActivity",
      component: performanceActivity,
      meta: { authorize: [Role.HRAdmin, Role.HCPM, Role.TLPM] }
    },
    {
      path: "/activity-status",
      name: "activityStatus",
      component: activityStatus
      // meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/key-performance-indicator",
      name: "keyPerformanceIndicator",
      component: keyPerformanceIndicator
      // meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/questions",
      name: "questions",
      component: questions
      // meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/review-period",
      name: "reviewPeriod",
      component: reviewPeriod
      // meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/field-set",
      name: "fieldSet",
      component: fieldSet
      // meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/activity-type",
      name: "activityType",
      component: activityType
      // meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/activity-category",
      name: "activityCategory",
      component: activityCategory
      // meta: { authorize: [Role.HRAdmin] },
    },
    {
      path: "/holidays",
      name: "holidays",
      component: holiday,
      meta: { authorize: [Role.HRAdmin] }
    },
    {
      path: "/query",
      name: "query",
      component: query,
      meta: { authorize: [Role.HRAdmin, Role.HODR, Role.HCRM, Role.TCRM] }
    },
    {
      path: "/employee-query",
      name: "employeequery",
      component: employeeQuery,
      meta: { authorize: [Role.Employee] }
    },
    {
      path: "/change-password",
      name: "changePassword",
      component: changePassword,
      meta: { authorize: [Role.HRAdmin, Role.Employee, Role.Admin] }
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      component: forgotPassword,
      meta: { authorize: [Role.HRAdmin, Role.Employee, Role.Admin] }
    }
  ],

  linkActiveClass: "active"
});
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = authenticationService.currentUserValue;

  if (authorize) {
    if (!currentUser) {
      // not logged in so redirect to login page with the return url
      return next({ path: "/login" });
    }
    var p = currentUser.employee
      ? currentUser.employee.status == 3
        ? "onboarddetails"
        : "employeedashboard"
      : "companies";
    // check if route is restricted by role
    if (
      authorize.length &&
      currentUser.roles.every(e => !authorize.includes(e))
    ) {
      // role not authorised so redirect to home page
      if (currentUser.user.userType == 1) {
        return next({ name: "companies" });
      } else if (currentUser.user.userType == 3) {
        return next({ name: p });
      } else {
        return next({ path: "/" });
      }
    }
  }

  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js